import React, { useEffect, useState } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import Paper from '@material-ui/core/Paper'

import { Icon, SimpleLoadingSpinner } from 'src/chrome'

import styles from './modal.module.scss'

interface ModalProps {
  animationStyle?: 'slide' | 'fade' // fade or slide, slide is default
  bodyChildren?: React.ReactNode
  footerChildren?: React.ReactNode
  imageUrl?: string
  onClose: (object: any) => void
  title: string
  bodyStyles?: React.CSSProperties
  containerStyles?: React.CSSProperties
}

const Modal: React.FC<ModalProps> = props => {
  const [transition, setTransition] = useState(false)
  const [imageLoading, setImageLoading] = useState(false)

  const {
    bodyChildren,
    footerChildren,
    imageUrl,
    onClose,
    title,
    bodyStyles,
    containerStyles,
  } = props

  useEffect(() => {
    transitionNow(changeTransitionTrue)
  }, [])

  const transitionNow = (cb: () => void) => {
    setTimeout(cb, 100)
  }
  const changeTransitionTrue = () => {
    setTransition(true)
    return true
  }

  const handleClose = () => {
    setTransition(false)
    setTimeout(() => onClose({}), 200)
  }

  const style = {
    height: '100%',
    width: '100%',
  }

  const animationStyle =
    (props.animationStyle && styles[props.animationStyle]) || styles.slide
  return (
    <div key={'modal'}>
      <div
        className={`${animationStyle} ${styles.modal}`}
        style={containerStyles}
      >
        <TransitionGroup>
          <CSSTransition classNames={styles} timeout={200}>
            <React.Fragment>
              {transition && (
                <Paper style={style}>
                  <span className={styles.closeButton} onClick={handleClose}>
                    <Icon icon={'CLOSE'} size={16} />
                  </span>
                  <div className={styles.modalContent}>
                    {imageUrl && (
                      <div className={styles.imageContainer}>
                        {imageLoading && <SimpleLoadingSpinner />}
                        <img
                          src={imageUrl}
                          onLoad={() => {
                            setImageLoading(false)
                          }}
                          onError={() => {
                            setImageLoading(false)
                          }}
                          alt={title}
                          style={imageLoading ? { visibility: 'hidden' } : {}}
                        />
                      </div>
                    )}
                    <div className={styles.rightContainer}>
                      <div className={styles.content}>
                        <h1 style={{ color: '#6F8394' }}>{title}</h1>
                        <div className={styles.body} style={bodyStyles}>
                          {bodyChildren}
                        </div>
                        <div className={styles.footer}>{footerChildren}</div>
                      </div>
                    </div>
                  </div>
                </Paper>
              )}
            </React.Fragment>
          </CSSTransition>
        </TransitionGroup>
      </div>
      <div className={styles.overlay} />
    </div>
  )
}

export default Modal
